<template>
  <div class="modal__comments-container">
    <div class="modal__comments-header"><i class="far fa-comments"></i> {{ commentCountText }}</div>
    <div class="grid modal__comments-area">
      <div class="grid__col--6">
        <CommentsDisplay :comments="comments"></CommentsDisplay>
      </div>
      <div class="grid__col--6">
        <CommentForm></CommentForm>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import CommentsDisplay from './CommentsDisplay.vue';
  import CommentForm from './CommentForm.vue';

  export default {
    name: 'CommentsContainer',
    components: {
      CommentsDisplay,
      CommentForm,
    },
    computed: {
      ...mapGetters('meetingAgendas', ['currentAgendaItemComments']),
      comments() {
        return this.currentAgendaItemComments;
      },
      commentCount() {
        return this.comments.length;
      },
      commentCountText() {
        return `${this.commentCount} Comment${ this.commentCount === 1 ? '' : 's'}`;
      },
    },
  };
</script>
